import { AlgorithmList, VersionList } from "../../models/ewb.model"

export class GetVersionsList{
static readonly type ='[EWB-Configuration] Get Versions list'
constructor(public modelId: number){}
}
export class GetModels {
  static readonly type ='[EWB-Configuration] Get Algorithm list'
}
export class GetInputId{
  static readonly type ='[EWB-Configuration] Set version InputId'
  constructor(public versionId: number){}
}
export class SetSelectedAlgorithm {
  static readonly type ='[EWB-Configuration] Set selected algorithm'
  constructor(public algorithm:AlgorithmList[] ){}
}


export class SetSelectedVersion {
  static readonly type ='[EWB-Configuration] Set selected version'
  constructor(public version:VersionList[] ){}
}

export class SetAlgoLoading {
  static readonly  type = '[EWB-Configuration] Set Algo Loading'
  constructor(public loading: boolean) {}
}
export class GetThemes {
  static readonly type = "[EWB-Configuration] Get themes";
  constructor(public configurationId: string) {}
}
export class MoveStep {
  static readonly type ='[EWB-Configuration] Next Step'
  constructor(public moveToStepIndex: number) {}
}
export class UpdateStepValidity {
  static readonly type ='[EWB-Configuration] Update Step Validity'
  constructor(public stepIndex: number, public validity: boolean) {}
}
export class SetThresholdUomConfig {
  static readonly type = '[EWB-Configuration] Set threshold config'
  constructor(public config: any) {}
}
export class SetSelectedConfigType {
  static readonly type = '[EWB-Configuration] Set Selected Type data'
  constructor(public selectedType: any){}
}
export class GetJwtToken{
  static readonly type = '[EWB-Configuration] Get token'
}

export class ClearEwbConfigState{
  static readonly type = '[EWB-Configuration] Clear selections'
}
export class GetAlgorithmList {
  static readonly type ='[EWB-Configuration] Get Algorithm list'
  constructor(public configurationId: string){}
}


export class GetAlgorithmAssetList {
  static readonly type ='[EWB-Configuration] Get Algorithm Asset list'
  constructor(public modelList: any, public refreshList?: boolean){}
}

export class SetSelectedAssetList {
  static readonly type ='[EWB-Configuration] Set selected Asset List'
  constructor(public selectedAssets: any){}
}

export class RemoveSelectedAsset {
  static readonly type = '[EWB-Configuration] Removed Selected Asset'
  constructor(public selectedAsset: any){}
}

export class SetSelectedConfiguration {
  static readonly type = '[EWB-Configuration] Set selected Configuration'
  constructor(public configuration: any){}
}

export class GetKpiList {
  static readonly type = '[EWB-Configuration] Get KPI List'
  constructor(public plantId: string) {}
}

export class SetSelectedImpactedKPIs {
  static readonly type = '[EWB-Configuration] Set impacted KPIs'
  constructor(public impactedKPIs: any) {}
}

export class RemoveSelectedImpactedKPI {
  static readonly type = '[EWB-Configuration] Removed Selected Impacted Kpi'
  constructor(public impactedKPI: any){}
}

export class SubmitEwbConfiguration {
  static readonly type = '[EWB-Configuration] Submit Predictive Failure Configuration'
}

export class GetDepartments {
  static readonly type = "[EWB-Configuration] Get departments";
}
export class GetRoleIds {
  static readonly type = "[EWB-Configuration] Get Role IDs by plant";
}
export class GetRolesByPlant {
  static readonly type = "[EWB-Configuration] Get Roles by plant";
  constructor(public roleIdList: any[]) {}
}

export class GetRolesByDepartment {
  static readonly type = "[EWB-Configuration] Get Roles";
  constructor(public departmentId: string) {}
}


export class GetSubTypes {
  static readonly type = "[EWB-Configuration] Get Sub types";
  constructor(public themeId: string, public configurationId: string) {}
}

export class SetAssetsDuplicateDetected {
  static readonly type ='[EWB-Configuration] Set Asset duplicated detected'
  constructor(public duplicate: boolean) {}
}

export class RemoveConfiguredAssets {
  static readonly type ='[EWB-Configuration] Remove Asset Duplicates'
}


export class SetEwbMode {
  static readonly type ='[EWB-Configuration] Set Predictive failure mode'
  constructor(public mode: number) {}
}

export class SetEwbFailureMode {
  static readonly type ='[EWB-Configuration] Set Predictive failure mode'
  constructor(public mode: number) {}
}

export class GetEwbConfigurationDetails {
  static readonly type ='[EWB-Configuration] Get Configuration details'
  constructor(public configId: string) {}
}

export class CheckConfigurationUpdated {
  static readonly type ='[EWB-Configuration] Set Configuration Updated'
}

export class UpdateConfiguraitonDetails {
  static readonly type =`[EWB-Configuration] Update Configuration Details`
}


export class GetEWBTimeseries {
  static readonly type = "[EWB-Configuration] Get timeseries";
}


